import React, { useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { FloatCardComponent } from "../../../components/cards";
import allDonors from "../../../assets/data/allDonors.json";
import PageLayout from "../../../layouts/PageLayout";
import { PaginationComponent } from "../../../components";
import DonorTableComponent from "../../../components/tables/DonorTableComponent";

export default function AllDonor() {
  const { t } = useContext(TranslatorContext);

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"All Donors"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("home")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("Donor Management")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"All Donors"}</li>
              </ul>
            </div>
          </div>
        </Col>

        <Col xl={12}>
          <div className="mc-card">
            <Row>
              {/* <Col xs={12} sm={6} md={4} lg={3}>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["12 row", "24 row", "36 row"]}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md mb-4"
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <LabelFieldComponent
                                    label={t('rating_by')}
                                    option={["1 star", "2 star", "3 star", "4 star", "5 star"]}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md mb-4"
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <LabelFieldComponent
                                    label={t('category_by')}
                                    option={["mans", "womans", "kids", "accessory"]}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md mb-4"
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <LabelFieldComponent
                                    label={t('brand_by')}
                                    option={["ecstasy", "freeland", "rongdhonu"]}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md mb-4"
                                />
                            </Col> */}
              <Col xl={12}>
                <DonorTableComponent
                  thead={allDonors.thead}
                  tbody={allDonors.tbody}
                />
                <PaginationComponent />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}
